export default {
  online_shop: 'Online-Shop',
  storefront: 'Ladenfront',
  reservations: 'Reservierungen',
  import: 'Import',
};
